(function () {
  const cartRoot = document.querySelector('[data-cart-page]');
  const analyticsData = document.getElementById('jb-cart-analytics-data');
  if (!cartRoot || !analyticsData) return;

  let cart = {};
  try {
    cart = JSON.parse(analyticsData.textContent) || {};
  } catch (error) {
    return;
  }

  const baseData = {
    market: cart.market || '',
    currency: cart.currency || '',
    item_count: Number(cart.item_count || 0),
    cart_total: Number(cart.cart_total || 0),
    page: 'cart'
  };

  window.__jbCartAnalytics = window.__jbCartAnalytics || { events: [] };
  cartRoot.setAttribute('data-jb-analytics-ready', 'true');

  function syncQaState() {
    cartRoot.setAttribute('data-jb-analytics-events', JSON.stringify(window.__jbCartAnalytics.events));
  }

  syncQaState();

  function publishToShopify(eventName, data, attempt) {
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Promise.resolve(Shopify.analytics.publish(eventName, data)).catch(function () {});
      return;
    }

    if (attempt < 8) {
      setTimeout(function () {
        publishToShopify(eventName, data, attempt + 1);
      }, 250);
    }
  }

  function publish(type, details) {
    const data = Object.assign({}, baseData, details || {});
    const eventName = `jellybean:${type}`;
    const eventRecord = { event: eventName, data: data };

    window.__jbCartAnalytics.events.push(eventRecord);
    window.__jbCartAnalytics.events = window.__jbCartAnalytics.events.slice(-50);
    syncQaState();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: `jb_${type}`,
      jb_cart: data
    });

    publishToShopify(eventName, data, 0);
    document.dispatchEvent(new CustomEvent('jellybean:cart-analytics', { detail: eventRecord }));
  }

  function productDetails(element) {
    const card = element.closest('[data-jb-empty-product-card], .jb-pu-card');
    return {
      product_id: Number(element.dataset.productId || card?.dataset.productId || 0),
      product_handle: element.dataset.productHandle || card?.dataset.productHandle || '',
      product_title: element.dataset.productTitle || card?.querySelector('.jb-empty-product-card__title, .jb-pu-card__title')?.textContent.trim() || '',
      position: Number(element.dataset.position || card?.dataset.position || 0)
    };
  }

  publish('cart_view', {
    empty: Boolean(cart.empty),
    items: Array.isArray(cart.items) ? cart.items : []
  });

  if (cart.empty) {
    publish('empty_cart_view', {
      products: Array.from(document.querySelectorAll('[data-jb-empty-product-card]')).map(function (card) {
        return {
          product_id: Number(card.dataset.productId || 0),
          product_handle: card.dataset.productHandle || '',
          position: Number(card.dataset.position || 0)
        };
      })
    });
  }

  let recommendationsViewPublished = false;

  function publishRecommendationsView(details) {
    if (recommendationsViewPublished) return;
    recommendationsViewPublished = true;
    publish('cart_recommendations_view', details || {});
  }

  document.addEventListener('jellybean:cart-recommendations-rendered', function (event) {
    publishRecommendationsView(event.detail || {});
  });

  (function findRenderedRecommendations(attempt) {
    const strip = document.getElementById('jb-page-upsell');
    const cards = Array.from(strip?.querySelectorAll('.jb-pu-card') || []);

    if (cards.length) {
      publishRecommendationsView({
        context: strip.dataset.recommendationContext || 'general',
        products: cards.map(function (card, index) {
          const action = card.querySelector('[data-jb-recommendation-action]');
          return {
            product_id: Number(card.dataset.productId || 0),
            product_handle: card.dataset.productHandle || '',
            product_title: card.querySelector('.jb-pu-card__title')?.textContent.trim() || '',
            position: Number(card.dataset.position || index + 1),
            action: action?.dataset.action || 'link'
          };
        })
      });
      return;
    }

    if (attempt < 20 && !cart.empty) {
      setTimeout(function () {
        findRenderedRecommendations(attempt + 1);
      }, 250);
    }
  })(0);

  document.addEventListener('jellybean:cart-recommendation-added', function (event) {
    publish('cart_recommendation_add', event.detail || {});
  });

  document.addEventListener('click', function (event) {
    const emptyProductLink = event.target.closest('[data-jb-empty-product-link]');
    if (emptyProductLink) {
      publish('empty_cart_product_click', Object.assign(productDetails(emptyProductLink), {
        action: emptyProductLink.dataset.action || 'link'
      }));
      return;
    }

    if (event.target.closest('[data-jb-empty-shop-all]')) {
      publish('empty_cart_shop_all_click');
      return;
    }

    const recommendationAction = event.target.closest('[data-jb-recommendation-action]');
    if (recommendationAction) {
      publish('cart_recommendation_click', Object.assign(productDetails(recommendationAction), {
        action: recommendationAction.dataset.action || 'link',
        context: recommendationAction.closest('#jb-page-upsell')?.dataset.recommendationContext || ''
      }));
      return;
    }

    const quantityButton = event.target.closest('.cart__quantity-minus, .cart__quantity-plus');
    if (quantityButton) {
      const item = quantityButton.closest('[data-item]');
      const input = item?.querySelector('input[name="updates[]"]');
      Promise.resolve().then(function () {
        publish('cart_quantity_change', {
          line_key: item?.dataset.item || '',
          product_title: item?.dataset.itemTitle || '',
          direction: quantityButton.classList.contains('cart__quantity-plus') ? 'increase' : 'decrease',
          quantity: Number(input?.value || 0)
        });
      });
      return;
    }

    const removeButton = event.target.closest('[data-item-remove]');
    if (removeButton) {
      const item = removeButton.closest('[data-item]');
      publish('cart_remove', {
        line_key: item?.dataset.item || removeButton.dataset.id || '',
        product_title: item?.dataset.itemTitle || '',
        type: 'item'
      });
      return;
    }

    const bundleRemoveButton = event.target.closest('[data-jb-remove-bundle]');
    if (bundleRemoveButton) {
      const bundle = bundleRemoveButton.closest('[data-jb-cart-bundle]');
      publish('cart_remove', {
        bundle_id: bundle?.dataset.bundleKey || '',
        type: 'bundle'
      });
      return;
    }

    const bundleEditLink = event.target.closest('.jb-cart-bundle-group__edit');
    if (bundleEditLink) {
      publish('cart_bundle_edit', {
        destination: bundleEditLink.getAttribute('href') || ''
      });
      return;
    }

    if (event.target.closest('[name="checkout"], [data-cart-checkout-button] button, redo-shopify-toggle [role="button"], redo-shopify-toggle a[href*="checkout"]')) {
      publish('cart_checkout_click');
    }
  });
})();
